module.exports = __webpack_public_path__ + "static/creatorWeekBG-9f86aab070ad4994ac94eaa9d9d0692e.jpg";